import { JobStatus } from '@doc-abode/data-models';

export const abortedJobStatuses = [JobStatus.CONTROLLER_ABORTED, JobStatus.HCP_ABORTED];
